<mon-page-layout [header]="'adminDashboard.page.title' | transloco"
                [subheader]="'adminDashboard.page.description' | transloco">
    <h2 class="dashboard-cards-header tw-my-0">{{ 'adminDashboard.page.cardsHeader' | transloco }}</h2>
    <div class="cards-container tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-pt-8">
        <p-card *ngFor="let card of visibleCardItems; let i = index"
                class="tw-cursor-pointer tw-h-full tw-rounded-xl hover:tw-shadow-lg focus:tw-shadow-lg"
                tabindex="0"
                role="button"
                [attr.aria-labelledby]="'card-title-' + i"
                [attr.aria-describedby]="'card-desc-' + i"
                [attr.data-test]="'admin-dashboard-quick-action-card-' + i"
                (click)="card.action()"
                (keydown.enter)="card.action()"> 
            <ng-template #title> 
                <h3 class="card-heading tw-my-0" [attr.id]="'card-title-' + i">{{ card.title }}</h3>
            </ng-template>
            <p class="card-sub-text" [attr.id]="'card-desc-' + i">{{ card.description }}</p>
        </p-card>
    </div>
</mon-page-layout>